/**
 * EntityRouter — decides between the legacy EntityPage (people /
 * organisations extracted from topics) and the new ResearchEntityPage
 * (manufacturer / ingredient / disease / surveillance_system).
 *
 * Both URL schemes live at /entity/:slug for SEO unity. The router probes
 * the research-entity endpoint first; on 404 it falls back to the legacy
 * EntityPage component. This keeps both systems on the same canonical
 * URL space without disturbing the legacy admin.
 */
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "../../lib/api";
import ResearchEntityPage from "./ResearchEntityPage";
import LegacyEntityPage from "../EntityPage";

export default function EntityRouter() {
    const { slug } = useParams();
    const [decided, setDecided] = useState(null); // "research" | "legacy"

    useEffect(() => {
        let cancelled = false;
        api.get(`/research-entities/${slug}`)
            .then(() => { if (!cancelled) setDecided("research"); })
            .catch(() => { if (!cancelled) setDecided("legacy"); });
        return () => { cancelled = true; };
    }, [slug]);

    if (decided === null) {
        return <div className="min-h-screen bg-[#0B1220] text-[#94A3B8] flex items-center justify-center">Loading…</div>;
    }
    return decided === "research" ? <ResearchEntityPage /> : <LegacyEntityPage />;
}
